import { Session } from '../entities';
import { ISessionRepository } from '../../data/repositories/ISessionRepository';

export interface OpenSessionRequest {
  userId: number;
  siteId: number;
  typeOfWorkId: number;
  startTime: string;
  notes?: string;
}

export interface OpenSessionResponse {
  session: Session;
  success: boolean;
  message: string;
}

export class OpenSession {
  constructor(private sessionRepository: ISessionRepository) {}

  async execute(request: OpenSessionRequest): Promise<OpenSessionResponse> {
    try {
      // Проверяем, нет ли уже открытой сессии у пользователя
      const openSessions = await this.sessionRepository.getOpenSessionsForUser(request.userId);
      
      if (openSessions.length > 0) {
        return {
          session: openSessions[0],
          success: false,
          message: 'У пользователя уже есть открытая сессия'
        };
      }

      // Создаем новую сессию
      const session = await this.sessionRepository.createSession({
        ...request,
        endTime: undefined,
        duration: undefined
      });

      return {
        session,
        success: true,
        message: 'Сессия успешно открыта'
      };
    } catch (error) {
      throw new Error(`Ошибка при открытии сессии: ${error}`);
    }
  }
}
